import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    nav: {
      home: 'Home',
      blog: 'Knowledge Hub',
      about: 'About',
      download: 'Download App'
    },
    hero: {
      badge: '7 Years of Trust',
      title: 'Know the Benefits of Your Cold Press Juice',
      line1: 'Real ingredients',
      line2: 'Real benefits',
      line3: 'Real juice',
      subtitle: 'Create cold press juices with ingredients you already have. Discover health benefits and find juices for any specific goal.',
      cta: 'Download JuiceApp',
      secondary: 'Explore Recipes'
    },
    features: {
      title: 'Why JuiceApp?',
      subtitle: 'Discover the power of intelligent juicing',
      algorithm: {
        title: '1 Billion+ Recipes',
        desc: 'Our AI algorithm generates perfectly balanced juice combinations'
      },
      community: {
        title: 'Global Community',
        desc: 'Connect with juicers worldwide, share recipes, and get inspired'
      },
      nutrition: {
        title: 'Complete Nutrition Info',
        desc: 'Track sugar, calories, alkalinity, and health benefits'
      },
      synergy: {
        title: 'Smart Synergy',
        desc: 'Recipes optimized for harmony and sugar balance'
      }
    },
    blog: {
      title: 'Knowledge Hub',
      subtitle: 'Expert guides, recipes, and nutrition science',
      readMore: 'Read More',
      minRead: 'min read',
      allCategories: 'All Categories'
    },
    newsletter: {
      title: 'Join Our Juicing Community',
      subtitle: 'Get weekly recipes, health tips, and exclusive content delivered to your inbox.',
      placeholder: 'Enter your email',
      button: 'Subscribe',
      success: 'Welcome! Check your inbox.',
      error: 'Something went wrong. Try again.'
    },
    footer: {
      tagline: 'Know the benefits of your cold press juice',
      rights: 'All rights reserved',
      categories: 'Categories',
      company: 'Company',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service'
    },
    article: {
      back: 'Back to Articles',
      share: 'Share',
      related: 'Related Articles'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      blog: 'Centre de Connaissances',
      about: 'À propos',
      download: 'Télécharger'
    },
    hero: {
      badge: '7 Ans de Confiance',
      title: 'Connaissez les Bienfaits de Votre Jus Pressé à Froid',
      subtitle: 'Créez des jus pressés à froid avec les ingrédients que vous avez déjà. Découvrez les bienfaits et trouvez des jus pour chaque objectif santé.',
      cta: 'Télécharger JuiceApp',
      secondary: 'Explorer les Recettes'
    },
    features: {
      title: 'Pourquoi JuiceApp ?',
      subtitle: 'Découvrez la puissance du juicing intelligent',
      algorithm: {
        title: '1 Milliard+ de Recettes',
        desc: 'Notre algorithme IA génère des combinaisons de jus parfaitement équilibrées'
      },
      community: {
        title: 'Communauté Mondiale',
        desc: 'Connectez-vous avec des juicers du monde entier'
      },
      nutrition: {
        title: 'Infos Nutritionnelles Complètes',
        desc: 'Suivez le sucre, les calories, l\'alcalinité et les bienfaits'
      },
      synergy: {
        title: 'Synergie Intelligente',
        desc: 'Recettes optimisées pour l\'harmonie et l\'équilibre du sucre'
      }
    },
    blog: {
      title: 'Centre de Connaissances',
      subtitle: 'Guides experts, recettes et science nutritionnelle',
      readMore: 'Lire Plus',
      minRead: 'min de lecture',
      allCategories: 'Toutes les Catégories'
    },
    newsletter: {
      title: 'Rejoignez Notre Communauté',
      subtitle: 'Recevez des recettes hebdomadaires et des conseils santé.',
      placeholder: 'Entrez votre email',
      button: 'S\'abonner',
      success: 'Bienvenue ! Vérifiez votre boîte mail.',
      error: 'Une erreur s\'est produite. Réessayez.'
    },
    footer: {
      tagline: 'Découvrez les bienfaits de votre jus pressé à froid',
      rights: 'Tous droits réservés',
      categories: 'Catégories',
      company: 'Entreprise',
      legal: 'Légal',
      privacy: 'Politique de Confidentialité',
      terms: 'Conditions d\'Utilisation'
    },
    article: {
      back: 'Retour aux Articles',
      share: 'Partager',
      related: 'Articles Connexes'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      blog: 'Centro de Conocimiento',
      about: 'Acerca de',
      download: 'Descargar'
    },
    hero: {
      badge: '7 Años de Confianza',
      title: 'Conoce los Beneficios de Tu Jugo Prensado en Frío',
      line1: 'Ingredientes reales',
      line2: 'Beneficios reales',
      line3: 'Jugo real',
      subtitle: 'Crea jugos prensados en frío con los ingredientes que ya tienes. Descubre beneficios y encuentra jugos para cualquier objetivo de salud.',
      cta: 'Descargar JuiceApp',
      secondary: 'Explorar Recetas'
    },
    features: {
      title: '¿Por qué JuiceApp?',
      subtitle: 'Descubre el poder del juicing inteligente',
      algorithm: {
        title: '1 Billón+ de Recetas',
        desc: 'Nuestro algoritmo de IA genera combinaciones de jugos perfectamente balanceadas'
      },
      community: {
        title: 'Comunidad Global',
        desc: 'Conecta con juicers de todo el mundo'
      },
      nutrition: {
        title: 'Info Nutricional Completa',
        desc: 'Rastrea azúcar, calorías, alcalinidad y beneficios'
      },
      synergy: {
        title: 'Sinergia Inteligente',
        desc: 'Recetas optimizadas para armonía y balance de azúcar'
      }
    },
    blog: {
      title: 'Centro de Conocimiento',
      subtitle: 'Guías expertas, recetas y ciencia nutricional',
      readMore: 'Leer Más',
      minRead: 'min de lectura',
      allCategories: 'Todas las Categorías'
    },
    newsletter: {
      title: 'Únete a Nuestra Comunidad',
      subtitle: 'Recibe recetas semanales y consejos de salud.',
      placeholder: 'Ingresa tu email',
      button: 'Suscribirse',
      success: '¡Bienvenido! Revisa tu correo.',
      error: 'Algo salió mal. Inténtalo de nuevo.'
    },
    footer: {
      tagline: 'Conoce los beneficios de tu jugo prensado en frío',
      rights: 'Todos los derechos reservados',
      categories: 'Categorías',
      company: 'Empresa',
      legal: 'Legal',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio'
    },
    article: {
      back: 'Volver a Artículos',
      share: 'Compartir',
      related: 'Artículos Relacionados'
    }
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const getLocalizedField = (item, field) => {
    if (language === 'en') return item[field];
    const localizedField = `${field}_${language}`;
    return item[localizedField] || item[field];
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, getLocalizedField }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
